
import { QRPayment } from "../../classes"

const QRPaymentModule = {
  namespaced: true,
  state: {
  },
  mutations: {

  },
  actions: {
    qrPaymentRequest: async ({ commit }, postData) => {
      try {
        let result = await QRPayment.qrPaymentRequest(postData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentCheckStatus: async ({ commit }, id) => {
      try {
        let result = await QRPayment.qrPaymentCheckStatus(id);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentInquiry: async ({ commit }, id) => {
      try {
        let result = await QRPayment.qrPaymentInquiry(id);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentLastRequest: async ({ commit }, postData) => {
      try {
        let result = await QRPayment.qrPaymentLastRequest(postData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentCancel: async ({ commit }, id) => {
      try {
        let result = await QRPayment.qrPaymentCancel(id);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentVoid: async ({ commit }, postData) => {
      try {
        let result = await QRPayment.qrPaymentVoid(postData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    qrPaymentVoidWithCancelPayment: async ({ commit }, postData) => {
      try {
        let result = await QRPayment.qrPaymentVoidWithCancelPayment(postData);
        return result;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {

  },
};
export default QRPaymentModule;
